import { HttpEventType } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { DocumentResponse } from '../model/documentResponse.model';
import { ApiUrlService } from './api-url.service';
import { DocumentsClientService } from './service-clients/documents-client.service';
import { HttpClientService } from './service-clients/http-client.service';

@Injectable({
    providedIn: 'root',
})
export class DocumentsService {
    private httpClient = inject(HttpClientService);
    private helperUrl = inject(ApiUrlService);
    private documentsClient = inject(DocumentsClientService);

    // @TODO: Ignored with eslint-interactive on 2023-09-15
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public uploadFile(file: File, comment: string, bsid: number): Observable<DocumentResponse | HttpEventType | any> {
        return this.httpClient.uploadFile(this.helperUrl.getAssistanceUrl(2) + `upload/bs/${bsid}/`, file, comment);
    }

    // @TODO: Ignored with eslint-interactive on 2023-09-15
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public openDocument(bsid: number, documentId: string): Observable<DocumentResponse | HttpEventType | any> {
        return this.httpClient.getAttachment(this.helperUrl.getAssistanceUrl(2) + `bs/${bsid}/documents/${documentId}`);
    }

    // @TODO: Ignored with eslint-interactive on 2023-09-15
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public getReferralDocument(referralId: string): Observable<DocumentResponse | HttpEventType | any> {
        // REST returns JSON { employeeId, data(Base64) } - convert to PDF Blob
        return this.documentsClient.getReferralDocument(referralId).pipe(
            map(res => {
                try {
                    const byteChars = atob(res.data);
                    const byteNumbers = new Array(byteChars.length);
                    for (let i = 0; i < byteChars.length; i++) {
                        byteNumbers[i] = byteChars.charCodeAt(i);
                    }
                    const byteArray = new Uint8Array(byteNumbers);
                    const blob = new Blob([byteArray], { type: 'application/pdf' });
                    // Preserve broad return type compatibility by returning the Blob
                    return blob;
                } catch (error) {
                    throw new Error(`Failed to decode Base64 PDF data`);
                }
            }),
        );
    }

    // @TODO: Ignored with eslint-interactive on 2023-09-15
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public combineMultipleDocuments(bsId: number, caseId: string, documentIds: string[]): Observable<DocumentResponse | HttpEventType | any> {
        return this.httpClient.getAttachmentPost(this.helperUrl.getAssistanceUrl(2, `bs/${bsId}/cases/${caseId}/documents/join`), documentIds);
    }

    // @TODO: Ignored with eslint-interactive on 2023-09-15
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public getDocument(bsid: number, documentId: number | string): Observable<DocumentResponse | HttpEventType | any> {
        return this.httpClient.getAttachment(this.helperUrl.getAssistanceUrl(2) + `bs/${bsid}/documents/${documentId}`);
    }
}
